module.exports = __webpack_public_path__ + "static/media/phaser.f81ed06f.svg";